import Vue from 'vue'
import Component from 'vue-class-component'
import { primaryColor } from '@/plugins/vuetify'
import { corLegivelNoTema } from '@/shareds/painel-do-cliente-shareds'

@Component
export default class CoresDoPainel extends Vue {
	get temaEscuro(): boolean {
		return this.$vuetify.theme.dark
	}

	get corPrimaria(): string {
		return this.corLegivel(primaryColor())
	}

	corLegivel(cor: string): string {
		return corLegivelNoTema(cor, this.temaEscuro)
	}
}
